import { useMemo } from 'react';
import { type SidebarBoxKey } from 'AdmissionsGuidance';
import { isCombinedMobileSidebarBox } from '../StudentDashboardSidebarTypeGuards';
import { useMobileBoxContext } from '../MobileSidebar/MobileBoxContext';

export function useIsPrimaryMobileBox(boxKey: SidebarBoxKey) {
    const mobileBoxConfig = useMobileBoxContext();
    return useMemo(() => {
        if (!mobileBoxConfig) return false;
        if (isCombinedMobileSidebarBox(mobileBoxConfig)) {
            return mobileBoxConfig.primary.key === boxKey;
        }
        return mobileBoxConfig.key === boxKey;
    }, [mobileBoxConfig, boxKey]);
}
